<h2 mat-dialog-title>Coverage</h2>

<mat-dialog-content>
    <form class="form" *ngIf="form" [formGroup]="form">

        <app-localization-text-form-field
            [formElement]="{ formControl: 'name', localizationValueParam: 'text', text: ('BenefitCoverageName' | translate: {Default: 'Name'}), disabled: 'false' }"
            [parentGroup]="form"
            [cultures]="cultures"
            (emitAddtoFormArray)="addNewLocalization()"
            (emitDeleteFromFormArray)="deleteLocalization($event.index)"
        ></app-localization-text-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">Close</button>
    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="!form.valid" *ngIf="form">Save</button> 
</mat-dialog-actions>